import { Button, Buttons, Currency, FormMessage, ModalCard } from '~/components';
import { useApi, useToast, useWorkspace } from '~/contexts';
import { useForm } from '~/hooks';
import React from 'react';
import styled from 'styled-components';
import { colors } from '~/styles';
import _ from 'lodash';
import pluralize from 'pluralize';

const CancelButton = styled(Button)`
  color: ${colors.grey40};
  background-color: ${colors.grey5};

  &:hover {
    color: ${colors.grey55};
    background-color: ${colors.grey10};
  }
`;

export default function ReimburseExpenseReportConfirmation({ title, items, isReimbursed, onClose, onReimburse }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const [formState, form] = useForm();
  const { isSubmitting, status, message } = formState;
  const toast = useToast();

  const handleReimburse = async () => {
    try {
      form.submit('batch');

      await api.www
        .workspaces(workspace.id)
        .expenseAdmin()
        .batchUpdateReimbursedStatus({ ids: items.map(({ id }) => id), isReimbursed });

      toast.success(
        `${items.length} expense ${pluralize('item', items.length)} set as ${isReimbursed ? 'reimbursed' : 'not reimbursed'}.`,
      );

      await onReimburse();
      form.save();
      onClose();
    } catch ({ message }) {
      toast.error(message);
      form.done();
    }
  };

  const total = _.sumBy(items, (item) => item.convertedTotal);

  return (
    <ModalCard title={`${isReimbursed ? 'Reimburse' : 'Unreimburse'} Expense Report`} onClose={onClose}>
      <ModalCard.Body>
        This will set {items.length} expense {pluralize('item', items.length)} in the <strong>{title}</strong> expense
        report as <strong>{isReimbursed ? 'reimbursed' : 'not reimbursed'}</strong> for a total of{' '}
        <strong>
          <Currency value={total} currency={workspace.currency} />
        </strong>
        . Are you sure?
        {status && <FormMessage.Error spaceTop>{message}</FormMessage.Error>}
      </ModalCard.Body>
      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={onClose}>Cancel</CancelButton>
          <Button disabled={isSubmitting} onClick={handleReimburse}>
            {isReimbursed ? 'Set as Reimbursed' : 'Set as Not Reimbursed'}
          </Button>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}
